"use client";

import React from "react";
import { Heart, Star, Infinity as InfinityIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const reasons = [{
  icon: Heart,
  title: "Patient-Centered Care",
  description: "We prioritize your unique health journey, ensuring every treatment plan is tailored to your specific needs, comfort levels, and long-term wellness goals."
}, {
  icon: Star,
  title: "Clinical Excellence",
  description: "Our practitioners combine years of clinical expertise with the latest evidence-based techniques to provide the highest standard of chiropractic care in Cyprus."
}, {
  icon: InfinityIcon,
  title: "Integrative Wellness",
  description: "Beyond spinal adjustments, we focus on your body's innate ability to heal, promoting structural balance, vitality, and a pain-free lifestyle for every patient."
}];
export default function ReasonsWhyLakshmiPalIsSpecial() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="181356" id="clinic-values" className="bg-background relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top,_var(--color-accent)_0%,_transparent_70%)] opacity-5" />

      <div className="container mx-auto px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-sans text-foreground text-4xl font-bold tracking-tight sm:text-5xl">
            Our Core Principles
          </h2>
          <p className="text-muted-foreground mt-4 text-lg leading-8 font-sans">
            Committed to restoring your mobility and enhancing your quality of life through expert care.
          </p>
        </div>

        <div ref={ref} className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3">
          {reasons.map((reason, i) => {
          const Icon = reason.icon;
          return <Card key={i} data-index={i} className={cn("group relative flex flex-col overflow-hidden rounded-2xl border border-border bg-card/50 shadow-sm backdrop-blur-sm transition-all duration-500 ease-out", "border-t-2 border-t-accent/20", "hover:-translate-y-2.5 hover:border-t-accent hover:shadow-xl hover:shadow-accent/10", "opacity-0 translate-y-12", isVisible && "opacity-100 translate-y-0")} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <CardHeader className="pb-4 pt-8 text-center">
                  <div className="mx-auto mb-4 flex size-16 items-center justify-center rounded-full bg-accent/5 ring-1 ring-accent/20 transition-transform duration-500 group-hover:scale-110 group-hover:bg-accent/10">
                    <Icon className="size-8 text-accent drop-shadow-[0_0_8px_var(--color-accent)]" />
                  </div>
                  <CardTitle className="font-sans text-foreground text-2xl font-semibold tracking-tight">
                    {reason.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-1 px-8 pb-8 text-center">
                  <p className="font-sans text-muted-foreground text-base leading-relaxed">
                    {reason.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}